import * as React from "react";
import { Form, Input, InputNumber, Icon, Checkbox, Select } from "antd";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import * as Constants from "../../../common/Constants";
import { IMenuItem } from "../../../model/menu/MenuItem";
import SelectInput from "../../components/app/SelectInput";

export interface State {}

export interface CreateMenuItemFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: IMenuItem[];
  rowData?: any;
}

const MenuItemForm = ({
  getFieldDecorator,
  translate,
  rowData,
  codebooks,
  getFieldValue,
  resetFields
}: {
  getFieldDecorator: any;
  translate: any;
  rowData?: any;
  codebooks: IMenuItem[];
  resetFields?:any;
  getFieldValue: any;
}) => {
  
  return (
    <Form>
      <Form.Item label={translate("menu_item_form.name")}>
        {getFieldDecorator(Constants.MenuItemInsertForm.Fields.NAME, {
          initialValue: rowData && rowData.name,
          rules: [
            {
              required: true,
              message: translate("menu_item_form.required_messages", {
                field: translate("menu_item_form.name")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>

      <Form.Item label={translate("menu_item_form.url")}>
        {getFieldDecorator(Constants.MenuItemInsertForm.Fields.URL, {
          initialValue: rowData && rowData.url,
          rules: [
            {
              required: true,
              message: translate("menu_item_form.required_messages", {
                field: translate("menu_item_form.url")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>

      <Form.Item label={translate("menu_item_form.description")}>
        {getFieldDecorator(Constants.MenuItemInsertForm.Fields.DESCRIPTION, {
          initialValue: rowData && rowData.description,
          rules: [
            {
              required: true,
              message: translate("menu_item_form.required_messages", {
                field: translate("menu_item_form.description")
              })
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Form.Item label={translate("menu_item_form.application_module")}>
        {getFieldDecorator(Constants.MenuItemInsertForm.Fields.APL_MODE_CODE, {
          initialValue: rowData && translate(`menu_item_form.${rowData.aplModCode}`)
        })(
          <Select
            onChange={()=>resetFields([Constants.MenuItemInsertForm.Fields.MENU_ITEM_ID])}
            placeholder={translate("menu_item_form.select_application_module")}
            allowClear
            showSearch={true}
            notFoundContent={translate("search.no_data")}
            disabled={rowData}
          >
            <Select.Option key={Constants.MenuItemInsertForm.Constants.MIK_BO}>
              {translate("menu_item_form.MIK_BO")}
            </Select.Option>
            <Select.Option
              key={Constants.MenuItemInsertForm.Constants.MIK_PUBLIC}
            >
              {translate("menu_item_form.MIK_PUBLIC")}
            </Select.Option>
          </Select>
        )}
      </Form.Item>

      <Form.Item label={translate("menu_item_form.menu_item_id")}>
        {getFieldDecorator(Constants.MenuItemInsertForm.Fields.MENU_ITEM_ID, {
          valuePropName:"value",
          initialValue: rowData && rowData.menuItemId?.toString(),
          rules: [
            {
              required: false,
              message: translate("menu_item_form.required_messages", {
                field: translate("menu_item_form.menu_item_id")
              })
            }
          ]
        })(
          <SelectInput
            placeholder={translate("menu_item_form.menu_item_id")}
            allowClear={true}
            showSearch={true}
            clearIcon={<Icon type="close" />}
            notFoundContent={translate("search.no_data")}
            selectOptionKey={"id"}
            selectOptionValue={"name"}
            selectOptions={codebooks.filter(item=>{return(rowData?item.aplModCode===rowData.aplModCode :item.aplModCode===getFieldValue(Constants.MenuItemInsertForm.Fields.APL_MODE_CODE))})}
          />
        )}
      </Form.Item>

      <Form.Item label={translate("menu_item_form.rbr")}>
        {getFieldDecorator(Constants.MenuItemInsertForm.Fields.RBR, {
          initialValue: rowData && rowData.rbr,
          rules: [
            {
              required: true,
              message: translate("menu_item_form.required_messages", {
                field: translate("menu_item_form.rbr")
              })
            }
          ]
        })(<InputNumber />)}
      </Form.Item>

      <Form.Item label={translate("menu_item_form.valid")}>
        {getFieldDecorator(Constants.MenuItemInsertForm.Fields.VALID, {
          valuePropName: "checked",
          initialValue: rowData ? rowData.valid : true,
          rules: [
            {
              required: true,
              message: translate("menu_item_form.required_messages", {
                field: translate("menu_item_form.valid")
              })
            }
          ]
        })(<Checkbox />)}
      </Form.Item>
    </Form>
  );
};

export default MenuItemForm;
